module.exports = __webpack_public_path__ + "public/static/img/img-section4-2-2.071a9e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-section4-2-2.svg
// module id = 5lzb
// module chunks = 1